module.exports = __webpack_public_path__ + "img/default.4b1287b9.png";